import { AxleOrgSyncOrgFragment } from "../../../../../../types";
import { OrgsListBase } from ".";

interface OrgsListUnlinkedProps {
  selectedId: string | null;
  searchQuery: string;
  onLink: (org: AxleOrgSyncOrgFragment) => void;
  orgs: readonly AxleOrgSyncOrgFragment[];
  loading: boolean;
}

export const OrgsListUnlinked = (props: OrgsListUnlinkedProps) => {
  const { selectedId } = props;

  return (
    <OrgsListBase
      {...props}
      title="Unlinked Nutrition Orgs"
      columnMode={"Link"}
      filterOrg={({ isLinked, hasSearchQueryMatch, isSelected }) => {
        if (isLinked) {
          return false;
        }
        return isSelected || hasSearchQueryMatch;
      }}
    />
  );
};
